import React from 'react';

import PropTypes from 'prop-types';

import smoothscroll from 'smoothscroll-polyfill';

import './navbar.scss';

import Logo from '../Logo';

// eslint-disable-next-line
class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      hidden: false,
    };
    this.navs = [
      'About', 'Judges', 'Sponsors', 'Schedule', 'FAQ',
    ];
    this.toggleNav = () => {
      this.nav.scrollTop = 0;
      this.setState({ active: !this.state.active, hidden: false });
    };
    this.scrollTo = (e) => {
      if (this.state.active) this.toggleNav();
      const { href } = e.target;
      document.getElementById(href.substr(href.indexOf('#') + 1)).scrollIntoView({ behavior: 'smooth' });
    };
    this.navRef = (e) => {
      this.nav = e;
    };
    this.onResize = () => {
      if (window.innerWidth > 935 && this.state.active) this.toggleNav();
    };
    this.onScroll = () => {
      if (!this.state.active) {
        const { scrollY } = window;
        // visible, scrolled down
        if (!this.state.hidden && scrollY > this.lastScrollPosition && scrollY >= 5) {
          this.setState({ hidden: true });
          document.body.classList.add('nav-hidden');
        // hidden, scrolled up
        } else if ((this.state.hidden && scrollY < this.lastScrollPosition) || scrollY < 5) {
          this.setState({ hidden: false });
          document.body.classList.remove('nav-hidden');
        }
        this.lastScrollPosition = scrollY;
      }
    };
  }
  componentDidMount() {
    // kick off the polyfill!
    smoothscroll.polyfill();
    this.lastScrollPosition = window.scrollY;
    window.addEventListener('resize', this.onResize);
    window.addEventListener('scroll', this.onScroll);
    // window loaded
    if (document.readyState === 'complete') {
      document.documentElement.style = 'scroll-behavior: smooth';
    } else {
      window.addEventListener('load', () => {
        document.documentElement.style = 'scroll-behavior: smooth';
      });
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('scroll', this.onScroll);
  }
  render() {
    const { active } = this.state;
    const hidden = this.state.hidden || !this.props.loaded;
    return (
      <React.Fragment>
        <div className={`navbar-back${active ? ' active' : ''}${hidden ? ' hidden' : ''}`}>
          <div className="container navbar-back__container">
            <a aria-label="Home" href="/#Home" className="navbar__logo">
              <Logo />
            </a>
            <button aria-label="Toggle Navigation" className="navbar-back__hamburger" onClick={this.toggleNav}>
              <span />
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>
        <nav className={`navbar${active ? ' active' : ''}${hidden ? ' hidden' : ''}`} ref={this.navRef}>
          <div className="container navbar__container">
            <a aria-label="Home" href="/#Home" className="navbar__logo">
              <Logo />
            </a>
            <div className="navbar__items">
              {this.navs.map(nav => (
                <a
                  onClick={this.scrollTo}
                  href={`/#${nav}`}
                  key={nav}
                  className="navbar__item"
                >
                  {nav}
                </a>
              ))}
              <a
                href="https://2017.hackthenorth.com"
                className="navbar__item"
              >
                2017
              </a>
            </div>
          </div>
        </nav>
      </React.Fragment>
    );
  }
}

Navbar.propTypes = {
  loaded: PropTypes.bool,
};

Navbar.defaultProps = {
  loaded: true,
};

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar/index.jsx